

(function(){
    'use strict';

    $(document).ready(function() {
        $('.data-table').each(function() {
            $(this).dataTable = $(this).DataTable();
            // $(this).closest('.dataTables_wrapper').addClass('responsive-table');
            $(this).wrap('<div class="responsive-table"></div>');
        });
    });
}());
